import { ToastContainer as ToastifyToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './customToastify.css'

export function ToastContainer() {
  return (
    <ToastifyToastContainer
      position="bottom-right"
      className=""
      toastClassName=""
      icon={false}
      closeButton={false}
      hideProgressBar={true}
      limit={3}
    />
  )
}
